import BookmarkAddIcon from '@mui/icons-material/BookmarkAdd';
import CopyAllIcon from '@mui/icons-material/CopyAll';
import { Container, Divider, Stack, Typography } from "@mui/material";
import { Box } from "@mui/system";
import { Notification, useNotification } from 'Components/Notification';
import { ResourceElementsBorderRadius, ResourceTitleStack } from 'Components/Resources/Resources.styled';
import { useAppSelector } from 'helpers/hooks';
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ShButton } from 'shared/SharedStyles/ShInputs';
import { ShPaper } from 'shared/SharedStyles/ShSurfaces';

export const AiInterviewQuestionsPage = () => {
    const navigate = useNavigate();
    const { aiInterviewQuestions } = useAppSelector(state => state.app.resources);
    const notification = useNotification();
    const [copiedToClipboard, setCopiedToClipboard] = useState(false);

    useEffect(() => {
        if (!aiInterviewQuestions) {
            navigate('/resources');
        }
    }, [aiInterviewQuestions, navigate]);

    useEffect(() => {
        if (copiedToClipboard) {
            notification.displayNotification({
                open: true,
                type: 'success',
                message: 'Successfully Copied!'
            });
            setCopiedToClipboard(false);
        }
    }, [copiedToClipboard, notification]);

    const handleCopyAllClick = () => {
        const questionsAndAnswers = aiInterviewQuestions?.description?.questions?.map(q => `${q.question}\n${q.answer}`).join('\n\n') ?? '';
        navigator.clipboard.writeText(questionsAndAnswers)
            .then(() => {
                setCopiedToClipboard(true);
            })
    };

    return (
        <Container maxWidth='lg'>
            <ResourceTitleStack columnGap={1} rowGap={1} />
            <ShPaper variant='outlined' borderRadius={ResourceElementsBorderRadius}>
                <Stack direction={{ xs: 'column', sm: 'row' }} justifyContent='right' paddingLeft={1} paddingBottom={1} paddingTop={2}>
                    <ShButton color='success' href="https://app.smoothhiring.com/employers/new">
                        <BookmarkAddIcon />
                        <Typography variant="body2">Post This Job to 100+ Boards Instantly!</Typography>
                    </ShButton>
                    <ShButton color='primary' onClick={handleCopyAllClick}>
                        <CopyAllIcon />
                        <Typography variant="body2">Copy</Typography>
                    </ShButton>
                </Stack>
                <Stack paddingLeft={1}>
                    {aiInterviewQuestions?.description?.questions?.map((q, index) =>
                        <Box padding={1} key={index + '_q_a_pair'}>
                            <Stack direction="row" alignItems="center" spacing={1}>
                                <Typography variant="subtitle1" fontWeight={'bold'}>{q.question}</Typography>
                            </Stack>
                            <Stack direction="row" alignItems="center">
                                <Typography marginBottom={2} variant="body2">{q.answer}</Typography>
                            </Stack>
                            {index !== aiInterviewQuestions?.description?.questions?.length - 1 && <Divider />}
                        </Box>)}
                </Stack>
            </ShPaper>
            <Notification />
        </Container>
    );
}
